import * as type from "../types";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const Cryptr = require("cryptr");
const cryptr = new Cryptr(process.env.REACT_APP_SANYKO);

export function getUser(user) {
  return {
    type: type.GET_USER,
    payload: user,
  };
}
export function setUser(user) {
  let cookUser = cryptr.encrypt(JSON.stringify(user));

  cookies.set("user", cookUser, {
    maxAge: 10800,
    httpOnly: true,
    secure: true,
  });

  return {
    type: type.SET_USER,
    payload: user,
  };
}
